/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import type { ComponentTheme } from "models/theme.model";

const linkTheme: ComponentTheme<"MuiLink"> = {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};

export default linkTheme;
